import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostContentOffersLoading, EGetPostContentOffersActionType } from './types';
import { IPostContentRecommendedOffers } from '../../../types/postContentRecommendedOffers';

export const getPostContentOffersLoading: (id: IPostContentRecommendedOffers['id']) => TGetPostContentOffersLoading =
  actionGenerator<EGetPostContentOffersActionType.Loading, IPostContentRecommendedOffers['id']>(
    EGetPostContentOffersActionType.Loading,
  );
